import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    height: 100%;
    font-size: 16px;
  }

  body {
    height: 100%;
    display: flex;
    flex-direction: column;
    * {
      box-sizing: border-box;
    }
  }

  .environment-info-banner {
    align-items: center;
    column-gap: 4px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 50px;
    justify-content: center;
    padding: 4px;
    width: 100%;
  }

  .environment-info-development-banner {
    background-color: var(--color-surface);
    border: 2px solid var(--color-surface-border);
    color: var(--color-on-surface);
  }

  .environment-info-test-branch-banner {
    background-color: var(--color-info-background);
    border: 2px solid var(--color-info-accent);
    color: var(--color-on-surface);
  }

  .hotjar-interview-survey > div {
    float: left;
    > div  {
      padding: 20px 0 20px 0;
      > div > div > div {
        box-shadow: none !important;
      }
    }
  }

  .hotjar-feedback-survey > div {
    float: left;
    > div  {
      padding: 96px 0 20px 0;
      > div > div > div {
        box-shadow: none !important;
      }
    }
  }

  .hotjar-survey-no-shadow ._hj-widget-container ._hj-5vKq2__styles__surveyContainer._hj-7Itnd__styles__inline{
    box-shadow: none !important;
  }

  /* Temp Hotjar unmasking
  .data-hj-suppress {
    color: red;
    border: 10px solid purple;
  }*/

  #grossArea ~ div, #livingFloorSpace ~ div {
    z-index: 0;
  }
`;

export const WrapXLgMarginBottom = styled.div`
  margin-bottom: 89px;
`;

export const WrapLgMarginBottom = styled.div`
  margin-bottom: var(--spacer-l);
`;

export const WrapMdMarginBottom = styled.div`
  margin-bottom: var(--spacer-m);
`;

export const WrapSmMarginBottom = styled.div`
  margin-bottom: var(--spacer-s);
`;

export const WrapSmMarginTop = styled.div`
  margin-top: var(--spacer-s);
`;

export const InlineP = styled.p`
  display: inline;
`;

export const A = styled.a``;

export const H2 = styled.h2``;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
